import { canonicalStringify } from '@apollo/client/utilities';
import type { MembershipFilter, PageInput } from '../../../generated';
import { cursorPaginationFieldPolicy } from '../../../utils/policies/cursorPaginationFieldPolicy';
import type { TypePolicies } from '../../../utils/types/TypePolicies';

// Invite queries ($resourceId) are keyed apart from settings lists; count-only (first: 0) selections stay separate.
const membershipsFieldPolicy = cursorPaginationFieldPolicy(
  (
    args: { filter?: MembershipFilter | null; page?: PageInput } | null,
    { variables }
  ) => {
    const { grantingResource, query } = args?.filter ?? {};

    return canonicalStringify({
      countOnly: args?.page?.first === 0 || undefined,
      grantingResource: grantingResource ?? undefined,
      invite: Boolean(variables?.resourceId) || undefined,
      query: query || undefined,
    });
  }
);

const resourceMembershipsFields = {
  directMemberships: membershipsFieldPolicy,
  indirectMemberships: membershipsFieldPolicy,
};

// Not on the Resource interface: its policy would override the keyFields asset subtypes inherit from Asset.
export const typePolicies: TypePolicies = {
  Asset: { fields: resourceMembershipsFields },
  // Its id is the user's, while lastActivityAt is specific to the project.
  MountedStorageRecentUser: { keyFields: false },
  Project: {
    fields: {
      ...resourceMembershipsFields,
      mountedStorageRecentUsers: cursorPaginationFieldPolicy(['days']),
    },
  },
  Workspace: { fields: resourceMembershipsFields },
};
